export default __webpack_public_path__ + "static/media/rug5-min.c1eff3ac.jpg";